import { render, staticRenderFns } from "./intercept.vue?vue&type=template&id=36c8a642&scoped=true"
import script from "./intercept.vue?vue&type=script&lang=js"
export * from "./intercept.vue?vue&type=script&lang=js"
import style0 from "./intercept.vue?vue&type=style&index=0&id=36c8a642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8a642",
  null
  
)

export default component.exports